import { Box, Text } from "@chakra-ui/react";
import { Info } from "lucide-react";
import { Tooltip } from "@/components/ui/tooltip";

export function FormField({
  label,
  hint,
  tooltip,
  children,
  error,
}: {
  label?: string;
  hint?: string;
  tooltip?: string;
  children: React.ReactNode;
  error?: string;
}) {
  return (
    <Box spaceY={1.5} data-onboarding-error={error ? "true" : undefined}>
      {label && (
        <Box spaceY={0.5}>
          <Box display="flex" alignItems="center" gap={1.5}>
            <Text fontSize="sm" fontWeight="medium" color="gray.700">
              {label}
            </Text>
            {tooltip && (
              <Tooltip
                content={tooltip}
                showArrow
                positioning={{ placement: "top" }}
                contentProps={{
                  bg: "gray.800",
                  color: "white",
                  fontSize: "sm",
                  fontWeight: "medium",
                  px: 3,
                  py: 2,
                  borderRadius: "md",
                  maxW: "260px",
                  textAlign: "center",
                  boxShadow: "lg",
                }}
              >
                <Box
                  as="span"
                  display="inline-flex"
                  alignItems="center"
                  justifyContent="center"
                  cursor="help"
                  color="gray.400"
                  transition="all 0.15s ease"
                  _hover={{ color: "gray.600" }}
                >
                  <Info size={14} />
                </Box>
              </Tooltip>
            )}
          </Box>
          {hint && <Text fontSize="xs" color="gray.400">{hint}</Text>}
        </Box>
      )}
      {children}
      {error && <Text fontSize="xs" color="red.500">{error}</Text>}
    </Box>
  );
}
